<template>
  <div>
    <a-modal :title="$t('startClass.title')" :visible="showClass" @ok="startClassNow" @cancel="showClass = false">
      <a-form :form="form">
        <a-form-item :label="$t('startClass.selectClass')" :colon="false">
          <a-select
            v-decorator="['classId', { rules: [{ required: true, message: $t('startClass.selectClass') }] }]"
            :placeholder="$t('startClass.selectClass')"
          >
            <a-select-option v-for="item in classList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { classMap, goClass } from '@/api/lesson'
export default {
  data() {
    return {
      showClass: false,
      form: this.$form.createForm(this),
      classList: [],
      lessonId: ''
    }
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async getClassList() {
      const res = await classMap()
      this.classList = res.data.list
    },
    selectClass(id) {
      if (!this.hasPermission('school_prepare_lesson')) {
        this.$message.error(this.$t('startClass.noPermission'))
        return
      }
      this.lessonId = id
      this.showClass = true
      this.$nextTick(() => {
        // 选中第一个
        if (this.classList.length === 0) return
        this.form.setFieldsValue({
          classId: this.classList[0].id
        })
      })
    },
    hasPermission(tag) {
      const permissionList = localStorage.permissionList || '[]'
      return permissionList && permissionList.includes(tag)
    },
    // 立即上课
    async startClassNow() {
      const data = {
        prepareLessonId: this.lessonId,
        classId: this.form.getFieldValue('classId')
      }
      const res = await goClass(data)
      if (res.code !== 200) return
      // 开启全屏
      this.enterFullscreen()
      this.$router.push({
        name: 'teaching',
        query: {
          id: this.lessonId,
          roomId: res.data.lessonId
        }
      })
    },
    enterFullscreen() {
      const element = document.documentElement // 选择整个文档
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        // Firefox
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        // Chrome, Safari 和 Opera
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        // IE/Edge
        element.msRequestFullscreen()
      }
      this.isFullscreen = true
      console.log('请求进入全屏模式')
    }
  },
  mounted() {
    this.getClassList()
  }
}
</script>

<style scoped lang="less"></style>
